<template>
    <div>
        <rkm-table
            :fields="fields"
            :filter-ignored-fields="['dataHoraAgendamento', 'usuarioAgendamento']"
            :items="agendamentos"
        >
            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    :id="uniqueId(`agendamento-detalhe-${item.id}`)"
                    small
                >
                    <rkm-icon icon="info" />
                </rkm-button>

                <rkm-popover
                    :target="uniqueId(`agendamento-detalhe-${item.id}`)"
                    placement="top"
                    title="Detalhes do agendamento"
                    triggers="hover"
                >
                    <div>
                        <span>
                            <strong>Usuário:</strong> {{item.usuarioAgendamento}}
                        </span>
                    </div>

                    <div>
                        <span>
                            <strong>Data/Hora:</strong> {{item.dataHoraAgendamento}}
                        </span>
                    </div>

                    <div v-if="item.motivoCancelamento">
                        <span>
                            <strong>Motivo cancelamento:</strong> {{ item.motivoCancelamento }}
                        </span>
                    </div>
                </rkm-popover>

                <rkm-button
                    :disabled="!item.permiteCancelamentoExclusao"
                    @click="print(item.id)"
                    color="info"
                    small
                    title="Imprimir protocolo"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="!item.permiteAlteracao"
                    @click="edit(item.id)"
                    authorize="update-ambulatorio-agendamento"
                    color="primary"
                    small
                    title="Reagendar"
                >
                    <rkm-icon icon="calendar-alt" />
                </rkm-button>

                <rkm-button
                    :disabled="!item.permiteCancelamentoExclusao"
                    @click="$refs.ModalCancelamento.open(item.id)"
                    authorize="update-ambulatorio-agendamento"
                    color="warning"
                    small
                    title="Cancelar"
                >
                    <rkm-icon icon="ban" />
                </rkm-button>

                <rkm-button
                    :disabled="!item.permiteCancelamentoExclusao"
                    @click="destroy(item.id)"
                    authorize="destroy-ambulatorio-agendamento"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalEdicao
            :paciente-id="pacienteId"
            @updated="$emit('updated')"
            ref="ModalEdicao"
        />

        <ModalCancelamento
            @canceled="$emit('canceled')"
            ref="ModalCancelamento"
        />
    </div>
</template>

<script>
// Components.
import ModalCancelamento from './components/cancelamento/Modal'
import ModalEdicao from '@/components/ambulatorio/agendamento/components/cadastro/Modal'

// Mixins.
import {error, file, formats, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        ModalCancelamento,
        ModalEdicao,
    },
    computed: {
        fields() {
            return [
                {key: 'unidade', label: 'Unidade', sortable: true},
                {key: 'infraestrutura', label: 'Local de atendimento', sortable: true},
                {key: 'usuario', label: 'Profissional', sortable: true},
                {key: 'ocupacao', label: 'CBO', sortable: true},
                {key: 'especialidade', label: 'Especialidade', sortable: true},
                {key: 'tipo', label: 'Tipo de atendimento', sortable: true},
                {formatter: value => this.formatDate(value), filterByFormatted: true, key: 'data', label: 'Data', sortable: true},
                {key: 'data', label: 'Data', sortable: true},
                {key: 'horario', label: 'Hora', sortable: true},
                {key: 'status', label: 'Status', sortable: true},
                {key: 'actions', label: 'Ações', class: 'col-min text-center'},
            ]
        },
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('ambulatorio.agendamento'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        print(id) {
            this.setLoading()

            this.repositories.impressao.agendamento(id)
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        edit(id) {
            if (this.additionals.cadastroPacienteVencido) {
                this.showWarningNotification(`Paciente com cadastro temporário desatualizado. Agendamento não permitido.`)
            }
            else if (!this.additionals.cnsValido) {
                this.showWarningNotification('Paciente com CNS inválido. Agendamento não permitido.')
            }
            else {
                if (this.additionals.avisaCnsProvisorio) {
                    this.showWarningNotification('Paciente com CNS provisório.')
                }

                this.$refs.ModalEdicao.edit(id)
            }
        },
        destroy(id) {
            const destroy = () => this.repositories.agendamento.destroy(id)
                .then(() => this.$emit('deleted'))

            this.showDeleteConfirmation('Deseja realmente excluir o agendamento?', destroy)
        },
    },
    mixins: [error, file, formats, repository, stringCase],
    props: {
        additionals: {type: Object, required: true},
        agendamentos: {type: Array, required: true},
        pacienteId: {type: [Number, String], required: true},
    },
}
</script>